<div class="top-post-container">
  <div class="row">
    <div class="col-md-12 d-flex flex-column flex-auto top-5-posts-body-table">
      <div class="row align-items-center top-5-posts-body-table-header">
        <div class="col-md-7 top-5-posts-body-table-col"></div>
        <div class="col-md-1 top-5-posts-body-table-col"></div>
        <div class="col-md-2 top-5-posts-body-table-col">
          <span class="d-flex justify-content-end text-capitalize pie-chart-reach-title">{{'common.measure.kpi_name.reach' | translate}}</span>
        </div>
        <div class="col-md-2 top-5-posts-body-table-col">
          <span class="d-flex justify-content-end text-capitalize pie-chart-impact-title">{{'common.measure.kpi_name.impact' | translate}}</span>
        </div>
      </div>
      <div class="row align-items-center top-5-posts-body-table-row top-post-placeholder" *ngFor="let post of topPostFakes; let i = index">
        <div class="col-md-7 top-5-posts-body-table-col">
          <div class="d-flex flex-row justify-content-start post-title">
            <span class="d-flex justify-content-end post-index">{{i + 1}}.</span>
            <span class="post-content">-</span>
          </div>
        </div>
        <div class="col-md-1 top-5-posts-body-table-col justify-content-center align-items-center">
          <span class="platform-icon">
            <img src="assets/images/question-mark.png" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" width="22px" height="22px">
          </span>
        </div>
        <div class="col-md-2 top-5-posts-body-table-col">
          <span class="d-flex flex-row flex-auto justify-content-end pie-chart-reach">- K</span>
        </div>
        <div class="col-md-2 top-5-posts-body-table-col">
          <span class="d-flex flex-row flex-auto justify-content-end pie-chart-impact">- %</span>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/post-overview/same-influencer-top-five-posts/top-post-placeholder/top-post-placeholder.component.html